import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, computed } from '@nuxtjs/composition-api'
import AlertLayout from './AlertLayout.vue'
import { DeleteConfirmConfig } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteConfirm',
  setup(__props, { expose }) {

const isOpen = ref(false)
const config = reactive<DeleteConfirmConfig>({
  inputContents: '',
  actionTitle: '삭제',
  cancelTitle: '취소'
})
const input = ref('')

const isAction = computed(() => config.inputContents === input.value)

const open = (param: DeleteConfirmConfig) => {
  input.value = ''

  config.inputContents = param.inputContents
  if (param.actionTitle) {
    config.actionTitle = param.actionTitle
  }
  if (param.cancelTitle) {
    config.cancelTitle = param.cancelTitle
  }
  config.action = param.action
  config.cancel = param.cancel

  isOpen.value = true
}

const close = () => {
  isOpen.value = false
}

const handleActionClick = () => {
  config.action && config.action()
  close()
}

const handleCancelClick = () => {
  config.cancel && config.cancel()
  close()
}

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  input.value = target.value
}

expose({ open, close })

return { __sfc: true,isOpen, config, input, isAction, open, close, handleActionClick, handleCancelClick, handleInput, AlertLayout }
}

})